import type { RootState } from 'state';
import type { FlightCalendarsFiltersState } from '../slice';

function getMonth(state: RootState): FlightCalendarsFiltersState['month'] {
  const { month } = state.flightCalendars.filtersValues;
  return month;
}

export default getMonth;
